import React from 'react';

// GLOBAL VARIABLES
import { ENVIRONMENTS } from 'globals.js';

// GLOBAL FUNCTIONS
import { getEnv, makePath } from 'functions.js';

// ROUTER COMPONENTS
import { Navigate, Route, Routes } from "react-router-dom";

// SCREENS
import AlertsModals from './routes/AlertsModals';
import DatePickers from './routes/DatePickers';
import FormElements from './routes/FormElements';
import ReactSelect from './routes/ReactSelect';

// MAIN COMPONENT
const Dev = () => (
  <Routes>
    {getEnv('key') === ENVIRONMENTS.dev.key ? [
      <Route
        key="forms"
        path={makePath('forms')}
        element={<FormElements />}
      />,
      <Route
        key="reactSelect"
        path={makePath('react-select')}
        element={<ReactSelect />}
      />,
      <Route
        key="datePickers"
        path={makePath('date-pickers')}
        element={<DatePickers />}
      />,
      <Route
        key="alerts"
        path={makePath('alerts')}
        element={<AlertsModals />}
      />
    ] : []}
    <Route path="*" element={<Navigate to={makePath('/')} replace />} />
  </Routes>
)

// EXPORT
export default Dev;
